import React from "react";
import { FaCheck, FaTimes, FaEye } from "react-icons/fa";

const StatusBadge = ({ status, type }) => {
  if (!status) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-600 border border-gray-200">
        <FaTimes size={10} />
        <span>No</span>
      </span>
    );
  }

  if (type === "opened") {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full bg-amber-50 text-amber-700 border border-amber-200">
        <FaEye size={10} />
        <span>Opened</span>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
      <FaCheck size={10} />
      <span>Accepted</span>
    </span>
  );
};
export default StatusBadge;
